import type { RunToDatabase } from '@/types'
import { portfolioTimezone } from '@pkg/basic'
import {
  type DatabaseWithTransaction,
  type Portfolio,
  insertPortfolio,
  selectPortfolio,
} from '@pkg/database-portfolio'

export const getPortfolio = async (params: {
  readFromDatabase: RunToDatabase
  writeToDatabase?: RunToDatabase
}): Promise<Portfolio> => {
  const { readFromDatabase, writeToDatabase } = params
  const portfolio = await readFromDatabase((database) =>
    selectPortfolio({ database }),
  )
  if (portfolio === undefined) {
    if (writeToDatabase === undefined) {
      throw new Error('Portfolio not found')
    }
    await writeToDatabase((database) => initPortfolio({ database }))
    const newPortfolio = await readFromDatabase((database) =>
      selectPortfolio({ database }),
    )
    if (newPortfolio === undefined) {
      throw new Error('Portfolio not found')
    }
    return newPortfolio
  }
  return portfolio
}

const initPortfolio = async (params: {
  database: DatabaseWithTransaction
}) => {
  const { database } = params

  const portfolioLocale = createPortfolioLocaleJp()

  await insertPortfolio({
    database,
    data: {
      ...portfolioLocale,
      id: 'id',
      name: 'name',
      needPeriodEndEvaluation: false,
      isTxGenerated: true,
    },
  })
}

type PortfolioLocale = Pick<
  Portfolio,
  'fiat' | 'timezone' | 'startMonth' | 'costBasis'
>

const createPortfolioLocaleJp = (): PortfolioLocale => ({
  fiat: 'jpy',
  timezone: portfolioTimezone,
  startMonth: 1,
  costBasis: 'WACB',
})
